// extracted by mini-css-extract-plugin
export var megaMenuItem = "MegaMenuItem-module--mega-menu-item--f66bd";